export default "__VITE_ASSET__6d34a750__"